import http from '@/http'
const URL = '/admin/participants'

export const list = async (params) => {
  // Sempre incluir group
  if (!params.include) {
    params.include = 'group'
  } else if (!params.include.includes('group')) {
    params.include += ',group'
  }
  const list = (await http.get(URL, { params: params }))
  return list
}

export const listNotAllocated = async (params) => {
  const list = (await http.get(URL + '/notAllocatedRoom', { params: params }))
  return list
}

export const listAttachments = async (id) => {
  const list = (await http.get(URL + `/${id}/attachments`))
  return list
}

// ===== Trilha presencial =====
export const journeyConfig = () => http.get('/admin/journey-marks/config')
export const journeyMarksList = () => http.get('/admin/journey-marks')
export const getParticipantMarks = (id) => http.get(`/admin/participants/${id}/journey-marks`)
export const setParticipantMarks = (id, markIds) => http.put(`/admin/participants/${id}/journey-marks`, { mark_ids: markIds })

export const listHistorics = async (id) => {
  const list = (await http.get(URL + `/${id}/historics?include=operator`))
  return list
}

export const listMails = async (id) => {
  const list = (await http.get(URL + `/${id}/messages`))
  return list
}

export const listWAMessages = async (id) => {
  const list = (await http.get(URL + `/${id}/waMessages`))
  return list
}

export const listPayments = async (id) => {
  const list = (await http.get(URL + `/${id}/orders?include=ticket,cupom`))
  return list
}

export const showTransaction = async (payload) => {
  let one = null
  if (payload.id) {
    one = (await http.get(URL + `/${payload.id}/orders/${payload.orderId}/transaction`))
  }
  return one
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}?include=tags,group,ref,transports,contact,companion,attachments,formData,registrationControlItem`))
  }
  return one
}

export const saveUser = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}

export const saveHistoric = (payload) => {
  return http.post(URL + `/${payload.participant_id}/historic`, payload)
}

export const uploadFile = (payload) => {
  return http.post(URL + `/attachment`, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const sendAttachMail = (payload) => {
  return http.post(URL + `/${payload.id}/email/attachment`, payload)
}

export const updateAttachment = (payload) => {
  if (payload.id) {
    return http.put(URL + `/attachment/${payload.id}`, payload)
  }
  return null
}

export const changeStatus = (payload) => http.put(URL + `/${payload.id}/status`, payload)
export const changeType = (payload) => http.put(URL + `/${payload.id}/type`, payload)

export const exportData = async (params) => {
  const data = (await http.get(URL + '/export', { params: params, responseType: 'blob' }))
  return data
}

export const deleteAttachment = async (id) => http.delete(URL + `/attachment/${id}`)
export const delParticipant = async (id) => http.delete(URL + `/${id}`)
export const delVoo = async (id) => http.delete(URL + `/voo/${id}`)

// ===================================================================
// DOCUMENT INTELLIGENCE - Análise de Anexos com IA
// ===================================================================
export const analyzeAttachment = (id) => http.post(URL + `/attachment/${id}/analyze`)
export const getAttachmentAnalysis = (id) => http.get(URL + `/attachment/${id}/analysis`)
export const applyAnalysisData = (id, fields) => http.post(URL + `/attachment/${id}/analysis/apply`, { fields })
export const retryAnalysis = (id) => http.post(URL + `/attachment/${id}/analysis/retry`)
export const getParticipantAnalyses = (participantId) => http.get(URL + `/${participantId}/analyses`)
export const dismissAnalysis = (analysisId) => http.post(URL + `/analysis/${analysisId}/dismiss`)
export const restoreAnalysis = (analysisId) => http.post(URL + `/analysis/${analysisId}/restore`)

// ===================================================================
// JOURNEY PROGRESS - Progresso das Jornadas
// ===================================================================
export const getJourneyProgress = async (participantIds) => {
  if (!participantIds || participantIds.length === 0) return { data: {} }
  const ids = participantIds.join(',')
  const res = await http.get(URL + '/journey-progress', { params: { ids } })
  return res.data
}

// ===================================================================
// NOVOS MÉTODOS PARA MINHAS FICHAS / DISTRIBUIÇÃO
// ===================================================================

export const getMyParticipants = async (params) => {
  // Sempre incluir group
  if (!params.include) {
    params.include = 'group'
  } else if (!params.include.includes('group')) {
    params.include += ',group'
  }
  const list = await http.get('/admin/my-participants', { params: params })
  return list
}

export const getAvailableParticipants = async (params) => {
  const list = await http.get('/admin/participants/available', { params: params })
  return list
}

export const assignParticipant = async (payload) => {
  return http.post('/admin/assign-participant', payload)
}

export const assignParticipantsAuto = async (payload) => {
  return http.post('/admin/assign-participants-auto', payload)
}

export const unassignParticipant = async (id) => {
  return http.delete(`/admin/assign-participant/${id}`)
}

export const getOperators = async () => {
  return http.get('/admin/operators')
}

// Auto-atribuir ao mudar status para "Em Andamento"
export const autoAssignOnStatusChange = async (participantId) => {
  return http.post('/admin/auto-assign-on-status-change', { participant_id: participantId })
}
// ===================================================================
// FORMULÁRIOS DINÂMICOS
// ===================================================================

/**
 * Busca o formulário vinculado ao grupo
 * @param {number} groupId - ID do grupo
 * @returns {Promise} Formulário com steps e fields
 */
export const getFormByGroupId = async (groupId) => {
  if (!groupId) return null
  try {
    const response = await http.get(`/admin/forms/byGroupId/${groupId}`)
    return response.data
  } catch (error) {
    // Se não houver formulário para o grupo, retorna null
    if (error.response?.status === 404) {
      return null
    }
    throw error
  }
}

// ===================================================================
// FICHA DO PARTICIPANTE (Card Builder)
// ===================================================================

/**
 * Busca a configuração da ficha para um participante
 * Retorna a ficha global com campos filtrados pela visibilidade do grupo
 * @param {number} participantId - ID do participante
 * @returns {Promise} Configuração da ficha com tabs e fields
 */
export const getAvailableColumns = async () => {
  const [fieldsRes, cardRes] = await Promise.all([
    http.get('/admin/participant-cards/fields/available'),
    http.get('/admin/participant-cards/global').catch(() => ({ data: null }))
  ])
  return { fields: fieldsRes.data, card: cardRes.data }
}

export const getParticipantCard = async (participantId) => {
  if (!participantId) return null
  try {
    const response = await http.get(`/admin/participant-cards/for-participant/${participantId}`)
    return response.data
  } catch (error) {
    // Se não houver ficha configurada, retorna null
    if (error.response && error.response.status === 404) {
      return null
    }
    throw error
  }
}

// ===================================================================
// VÍNCULO DE ACOMPANHANTE (Link/Unlink)
// ===================================================================

export const getAvailableForLinking = (params) =>
  http.get('/admin/companions/available-to-link', { params })

export const linkCompanion = (payload) =>
  http.post('/admin/companions/link', payload)

export const unlinkCompanion = (companionId) =>
  http.post(`/admin/companions/${companionId}/unlink`)

// Vínculo manual ao Controle de Inscrição (ficha)
export const searchRegistrationControlItems = (search) =>
  http.get(`${URL}/registration-control/search-items`, { params: { search } })

export const linkRegistrationControl = (participantId, payload) =>
  http.post(`${URL}/${participantId}/registration-control-link`, payload)

export const unlinkRegistrationControl = (participantId, payload = {}) =>
  http.delete(`${URL}/${participantId}/registration-control-link`, { data: payload })

export default {
  list,
  listNotAllocated,
  listAttachments,
  searchRegistrationControlItems,
  linkRegistrationControl,
  unlinkRegistrationControl,
  journeyConfig,
  journeyMarksList,
  getParticipantMarks,
  setParticipantMarks,
  listHistorics,
  listMails,
  listWAMessages,
  listPayments,
  showTransaction,
  show,
  saveUser,
  saveHistoric,
  sendAttachMail,
  uploadFile,
  changeStatus,
  changeType,
  exportData,
  deleteAttachment,
  updateAttachment,
  delParticipant,
  delVoo,
  getMyParticipants,
  getAvailableParticipants,
  assignParticipant,
  assignParticipantsAuto,
  unassignParticipant,
  getOperators,
  autoAssignOnStatusChange,
  getFormByGroupId,
  getParticipantCard,
  getAvailableColumns,
  getJourneyProgress,
  analyzeAttachment,
  getAttachmentAnalysis,
  applyAnalysisData,
  retryAnalysis,
  getParticipantAnalyses,
  dismissAnalysis,
  restoreAnalysis,
  getAvailableForLinking,
  linkCompanion,
  unlinkCompanion
}
